<template>
  <div class="MeetingRoomDemo">
    <div class="order-item-title">表单详情</div>
    <li class="boxShadow" @click="jump">
      <img :src="ServiceInfo.roomPic" alt="">
      <div class="content">
        <h3>{{ ServiceInfo.roomName }}</h3>
        <h4>价格：{{ ServiceInfo.minFee / 100 | PriceFilter }} 元起</h4>
        <p>容量：{{ ServiceInfo.capacityNum }} 人</p>
        <p>其他设备：{{ ServiceInfo.roomTag == '' ? '暂无详情' : ServiceInfo.roomTag }}</p>
      </div>
    </li>
    <div class="timeBox">
      <div class="boxTitle">预定时间</div>
      <p class="itemTime" v-for="(item, index) in ServiceInfo.roomOrderLis" :key="index">{{item.beginTime | DateFilter('yyyy-MM-dd hh:mm')}} - {{item.endTime | DateFilter('yyyy-MM-dd hh:mm')}}
        <span class="red fr">{{item.roomFee / 100 | PriceFilter}}元 </span>
      </p>
    </div>
    <!-- <div class="remark">
      <div class="boxTitle">附言</div>
      <div class="itemText">
        <el-input type="textarea" :rows="4"  v-model="info.remark" readonly ></el-input>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return{
      ServiceInfo: {},
      serviceMsg: {},
      serviceId: '',
    };
  },
  props: {
    info: {
      type: Object,
      default() {
        return{};
      },
    },
  },
  watch: {
    info() {
      this.ServiceInfo = this.info.orderServiceInfo;
    },
  },
  computed: {
    ...mapGetters(['parkServiceList']),
  },
  methods:{
    jump() {
      this.$router.push({ path: `/navigator/businessPlatform/meetingRoomDetail/${this.serviceId}/${this.ServiceInfo.id}` });
    },
    getServiceChildName() {
      const arrIndex = this.serviceMsg.children.findIndex((val) => {
        return val.type === 12;
      });
      if (arrIndex !== -1) {
        this.serviceId = this.serviceMsg.children[arrIndex].serviceId;
      }
    },
  },
  created() {
    this.serviceMsg = this.parkServiceList.find((val) => {
      return val.serviceFlag === 2;
    });
    this.getServiceChildName();
  }
}
</script>

<style lang="scss" scoped>
  li {
    width: 100%;
    height: 300px;
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
    display: flex;
    cursor: pointer;
    img {
      width: 535px;
      height: 100%;
      border-radius: 4px 0 0 4px;
    }
    .content{
      flex: 1;
      padding-left: 30px;    
      h3 {
        margin-top: 32px;
        margin-bottom: 20px;
        font-size: 30px;
        line-height: 30px;
      }
      h4 {
        font-size: 16px;
        color: #de2c32;
        margin-bottom: 25px;
      }
      p {
        color: #666;
        font-size: 14px;
      }
    }
    
  }
  .timeBox{
    font-size: 18px;
    margin-bottom: 10px;
    .boxTitle{
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .itemTime{
      font-size: 16px;
    }
  }
  .remark{
    font-size: 18px;
    .boxTitle{
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .itemText{
      font-size: 16px;
    }
  }
  .red{
    color:#de2c32;
  }
  .fr{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderDetails/MeetingRoomDemo.vue